
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import classNames from 'classnames'
import {
  UniConditionalRender,
  PermissionMapC,
  S10nModelC,
  ES10nModelType,
  darkThemeName,
  isSystemThemeDark,
  systemThemeName
} from '@unikey/unikey-commons/release/comm'

import {
  environment,
  api,
  mockAuth,
  SplashContainer,
  attemptRetrieveDealerDetails,
  attemptRetrieveAvailableSubscriptionModels,
  wrapWithInsights,
  attemptRetrieveAuthUser
} from '../internal'


import partnerConfig from '@alias-current-partner-customizations'
export interface ILocaleDefinitions {
  [key: string]: any
}

export interface IContainerCustomization {
  props?: any,
  render?(): any,
  aboveRender?(): any,
  belowRender?(): any,
}

export interface ICustomContainerConfigs {
  [key: string]: IContainerCustomization | IPartnerGlobalProps
}

export interface IPartnerConfig {
  assets: {
    [key: string]: any
  },
  locales: {
    en?: ILocaleDefinitions,
    es?: ILocaleDefinitions
  },
  containers: () => ICustomContainerConfigs,
  // captchaSiteKey: string,
  // captchaSecretKey: string
}


export interface IPartnerGlobalProps {
  noReadersFlow?: boolean,
}


const getPartnerOverrides = (containerKey: string): any => {
  const defaultOverride = {};
  const config: any = partnerConfig.containers();
  if (config && containerKey) {
    const containerConfig = config[containerKey];
    return containerConfig || defaultOverride;
  }
  // default override
  return defaultOverride;
}

export interface IPartnerCustomizations extends IPartnerGlobalProps {
  props: any,
  activeDealerId: string,
  activeS10n: S10nModelC,
  reactPluginAppInsights: any,
  darkModeTheme?: string,
  permissions?: PermissionMapC,
  currentExpiry?: string,
  tokenExpired?: boolean,
  tokenRefreshAttemptCompleted?: boolean,
  render(props?: any): any
  getAuthUser(ignoreCache: boolean): Promise<void>,
  getDealerDetails(dealerId: string): Promise<void>,
  setUserPermissionMap(permissions: PermissionMapC): void,
}

export interface IPartnerCustomizationOpts { 
  componentName: string,
  allowWithoutDealer?: boolean,
}


export const PartnerCustomizations = (WrappedComponent: React.ComponentType<any>, opts: IPartnerCustomizationOpts): any => {

  class CustomizedComponent extends Component<any> {
    partnerContainerConfig: any;
    extendedProps: any;
    
    constructor(props: any) {
      super(props);
      // Minimizinig for production builds affects the WrappedComponent.displayName here.
      // using specified componentName so that this works on obfuscated builds too.
      this.partnerContainerConfig = getPartnerOverrides(opts.componentName);
      this.extendedProps = Object.assign({}, props, this.partnerContainerConfig.props);

      // if (!opts.unauthenticated && !props.permissions) {
      //   props.getAuthUser(false).then(() => {
      //     if (!props.activeDealerId && !opts.allowWithoutDealer) {
      //       props.getDealerDetails(api.getDealerId());
      //     }
      //   });
      // }
      // // we need to have fetched the subscriptions before we can reliably show anything
      // if (!this.props.subscriptionRetreived) {
      //   this.props.getSubscriptionModels()
      // }
    }

    render() {
      const customizedWrappedComponentClass = classNames({
        // default is {}
        'partner-custom': Object.keys(this.partnerContainerConfig).length !== 0 && environment === 'development'
      });

      const customizedAboveComponentClass = classNames({
        'partner-custom': !!this.partnerContainerConfig.aboveRender && environment === 'development'
      });
      const customizedBelowComponentClass = classNames({
        'partner-custom': !!this.partnerContainerConfig.belowRender && environment === 'development'
      });

      const aboveElems = this.partnerContainerConfig.aboveRender ? (
        <div className={customizedAboveComponentClass}>
          {this.partnerContainerConfig.aboveRender()}
        </div>
      ) : '';

      const belowElems = this.partnerContainerConfig.belowRender ? (
        <div className={customizedBelowComponentClass}>
          {this.partnerContainerConfig.belowRender()}
        </div>
      ) : '';

      return (
        <>
          {/* render wrapped component */}
          {aboveElems}
          <div className={customizedWrappedComponentClass}>
            <WrappedComponent
              {...this.extendedProps}
              darkModeActive={
                this.props.darkModeTheme === darkThemeName 
                || (this.props.darkModeTheme === systemThemeName && isSystemThemeDark())
              }
              render={this.partnerContainerConfig.render}>
              {this.partnerContainerConfig.children}
            </WrappedComponent>
          </div>
          {belowElems}
        </>
      )
    }
  }

  const mapStateToProps = (state: any) => {
    return {
      activeDealerId: state.portal.activeDealer.id,
      activeS10n: state.subscriptionInfo.modelLookup.get(state.dealer.dealerData.subscriptionModel),
      permissions: state.authenticatedUser.currentUser?.permissions,
      subscriptionRetreived: !!state.subscriptionInfo.defaultType,
      darkModeTheme: state.portal.darkModeTheme,
      
      // tokenRefreshAttemptCompleted: state.oidcAuthStatus.refreshAttempted, 
      // currentExpiry: state.oidcAuthStatus.currentExpiry,
      // tokenExpired: state.oidcAuthStatus.isExpired
    }
  }

  const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    getDealerDetails: attemptRetrieveDealerDetails,
    getSubscriptionModels: attemptRetrieveAvailableSubscriptionModels,
    getAuthUser: attemptRetrieveAuthUser
  }, dispatch)

  const containerName: string = opts.componentName;
  return connect(mapStateToProps, mapDispatchToProps)(wrapWithInsights(CustomizedComponent, containerName));
}